module.exports = __webpack_public_path__ + "img/2025-01-09d_3.1b927faa.jpg";